module.exports = __webpack_public_path__ + "static/AnvitaPandey-75d029bdb2f6b880d57bb74c059f536d.png";